import config from "@/config/index";
import api from '../../utils/axios-util';
import * as mutation_type from "../mutation-types";
const state = config.WebHookManagement;
var getters = {
    GetWebhook: state => state.webhookmanagement,
}
const mutations = {
    [mutation_type.WebHookManagement]: (state, response) => {
        state.webhookmanagement = response;
    },
    [mutation_type.CommitNothing]: () => {

    }
};
const actions = {
    GetWebhook: ({ commit }) => {
        return new Promise((resolve, reject) => {
            try {
                api.get(`/webhook`).then(response => {
                    const webhook = response.data.data;
                    commit(mutation_type.WebHookManagement, webhook);
                    resolve(response);
                });
            } catch (error) {
                reject(error);
            }
        });
    },
    insertWebhook: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                api
                    .post(`/webhook`, payload)
                    .then(response => {
                        resolve(response);
                        commit(mutation_type.CommitNothing,{});
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    deleteWebhook: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                api
                    .delete(`/webhook/${payload}`)
                    .then(response => {
                        resolve(response);
                        commit(mutation_type.CommitNothing,{});
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    },
    updateWebhook: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                const id = payload.id;
                delete payload.id;
                api
                    .put(`/webhook/${id}`, payload)
                    .then(response => {
                        resolve(response);
                        commit(mutation_type.CommitNothing,{});
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            } catch (error) {
                reject(error);
            }
        });
    }
};
export default {
    state,
    getters,
    mutations,
    actions
}